import { render, staticRenderFns } from "./CheckBoxesDropdown.vue?vue&type=template&id=15c34a8d&"
import script from "./CheckBoxesDropdown.vue?vue&type=script&lang=ts&"
export * from "./CheckBoxesDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports